var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDimensions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    className: "dailoicon",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M259.8 118.9v267.8h109c37.5 0 67.2-12.3 89-37 22-24.6 32.9-57 32.9-97 0-39.9-11-72.2-32.9-96.9-21.9-24.6-51.5-37-89-37zM34.5 130.2v42.2h111l-82.3 69.9 22.3 30.5c8.3-3.3 18.5-5 30.5-5a56 56 0 0 1 36.3 11c9 7 13.5 16.9 13.5 29.5 0 12.8-4.1 23-12.4 30.5a50.8 50.8 0 0 1-34.7 11c-11.6 0-22.8-2-33.6-5.7-10.8-4-23.9-10.7-39.2-20L21.3 360c17.9 12 34.4 20.6 49.5 25.6 15.3 5 31.8 7.5 49.4 7.5 29.4 0 52.8-8.4 70.1-25.2a80.3 80.3 0 0 0 26.5-60 70 70 0 0 0-22.3-54.4c-14.3-13.5-33.6-21-57.7-22.2l70.2-59.6v-41.5zm278 33.2H361c23.4 0 41.7 7.6 55 23 13.6 15.3 20.4 37.5 20.4 66.4 0 29-6.8 51-20.3 66.4-13.4 15.4-31.7 23-55.1 23h-48.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDimensions);
export default __webpack_public_path__ + "static/media/three-dimensions.44d269cfc3d3603a13aa5e277e4a8ba5.svg";
export { ForwardRef as ReactComponent };